export const language: any ={
    cancel:"Hủy bỏ",
    ok:"Đồng ý",
}
